import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import { useOmniBaseDataServiceKind } from "../use-omni-base-data-service-kind";
import {
  OfferBaseDataTable,
  OfferBaseDataTableFilters,
  defaultOmniOfferBaseDataListRequest,
} from "@/services/backend/omni/offer/components/offer-base-data-table";
import { CreateOfferBaseDataDialog } from "@/services/backend/omni/offer/components/create-offer-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function OmniOffersBaseDataRoute() {
  const serviceKind = useOmniBaseDataServiceKind();
  const [request, setRequest] = useState(
    defaultOmniOfferBaseDataListRequest(serviceKind),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Angebote")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen ein neues Angebot angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateOfferBaseDataDialog serviceKind={serviceKind} />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <OfferBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <OfferBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
        />
      </CardContent>
    </Card>
  );
}
